import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "../lib/api";

export default function BlogPage() {
  const [posts, setPosts] = useState([]);
  useEffect(() => { api.get("/blog").then(({ data }) => setPosts(data)).catch(() => {}); }, []);
  return (
    <div className="mx-auto max-w-7xl px-4 py-10">
      <h1 className="font-heading text-3xl md:text-4xl font-bold tracking-tight">Blogs</h1>
      <p className="mt-2 text-sm text-slate-500">Padomi, specifikācijas un jaunumi par eļļām, auto ķīmiju un tehnikas apkopi.</p>
      <div className="mt-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {posts.map((b) => (
          <Link key={b.slug} to={`/blogs/${b.slug}`} data-testid={`blogpage-card-${b.slug}`} className="card-industrial group border border-border bg-white">
            <div className="aspect-[16/9] overflow-hidden bg-[#F4F8FC]">
              <img src={b.image} alt={b.title} loading="lazy" className="h-full w-full object-cover" />
            </div>
            <div className="p-6">
              <p className="text-xs text-slate-400">{new Date(b.date).toLocaleDateString("lv-LV")}</p>
              <h2 className="mt-2 font-heading text-lg font-semibold leading-snug group-hover:text-[#2E86D1]">{b.title}</h2>
              <p className="mt-2 text-sm text-slate-500 line-clamp-3">{b.excerpt}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}

export function BlogPostPage() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [notFound, setNotFound] = useState(false);
  useEffect(() => {
    window.scrollTo(0, 0);
    api.get(`/blog/${slug}`).then(({ data }) => setPost(data)).catch(() => setNotFound(true));
  }, [slug]);
  if (notFound) return <p className="py-24 text-center text-slate-500">Raksts nav atrasts.</p>;
  if (!post) return <div className="mx-auto max-w-3xl px-4 py-12"><div className="h-96 rounded-2xl bg-[#F4F8FC] animate-pulse" /></div>;
  return (
    <article className="mx-auto max-w-3xl px-4 py-10">
      <nav className="text-xs text-slate-500"><Link to="/" className="hover:text-[#2E86D1]">Sākums</Link> / <Link to="/blogs" className="hover:text-[#2E86D1]">Blogs</Link></nav>
      <h1 data-testid="blogpost-title" className="mt-4 font-heading text-3xl md:text-4xl font-bold tracking-tight leading-tight">{post.title}</h1>
      <p className="mt-2 text-sm text-slate-400">{new Date(post.date).toLocaleDateString("lv-LV")}</p>
      <img src={post.image} alt={post.title} className="mt-6 aspect-[16/8] w-full rounded-2xl object-cover" />
      <div className="mt-8 space-y-5">
        {post.body.map((par, i) => <p key={i} className="text-base leading-relaxed text-slate-700">{par}</p>)}
      </div>
      <div className="mt-10 rounded-2xl border border-border bg-[#F4F8FC] p-6 flex flex-wrap items-center justify-between gap-4">
        <p className="text-sm font-semibold">Nepieciešama konsultācija par produktu izvēli?</p>
        <Link to="/kontakti" className="btn-industrial bg-[#2E86D1] px-5 py-2.5 text-sm font-semibold text-white hover:bg-[#1F6DB2]">Sazināties ar mums</Link>
      </div>
    </article>
  );
}
